import { render, staticRenderFns } from "./First.vue?vue&type=template&id=70d3baa7&scoped=true&"
import script from "./First.vue?vue&type=script&lang=js&"
export * from "./First.vue?vue&type=script&lang=js&"
import style0 from "./First.vue?vue&type=style&index=0&id=70d3baa7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3baa7",
  null
  
)

export default component.exports